import { TreeGridColors } from "../treegrid/types"

// Style related constants
export const SANS_FONT_FAMILY = "'Inter', 'Helvetica', 'Arial', sans-serif"
export const COLOR_BLACK = "#141414"
export const COLOR_WHITE = "#ffffff"
export const COLOR_PRIMARY = "#1675b3"
export const COLOR_SECONDARY = "#4bd553"
export const COLOR_INFO = "#2a93fa"
export const COLOR_ERROR = "#ff3333"
export const COLOR_WARNING = "#fad820"
export const COLOR_GRAY = "#8c7388"
export const COLOR_DIVIDER = "#e8e7ed"
export const COLOR_LIGHT = "#f6f5ff"
export const COLOR_LOW_CONTRAST_NEUTRAL = "#b8b6c7"
export const COLOR_DARK_100 = "#454b75"

const initCssVariables = () => {
  const variables = {
    SANS_FONT_FAMILY,
    COLOR_BLACK,
    COLOR_WHITE,
    COLOR_PRIMARY,
    COLOR_SECONDARY,
    COLOR_INFO,
    COLOR_ERROR,
    COLOR_WARNING,
    COLOR_GRAY,
    COLOR_DIVIDER,
    COLOR_LIGHT,
    COLOR_LOW_CONTRAST_NEUTRAL,
    COLOR_DARK_100,
  }

  const cssVariables = Object.entries(variables)
    .map(([key, value]) => {
      const cssName = `--${key}`
      return `  ${cssName}: ${value};`
    })
    .join("\n")

  if (document) {
    const style = document.createElement("style")
    style.innerHTML = `:root {\n${cssVariables}\n}`
    document.head.appendChild(style)
  }
}

initCssVariables()

// Other consnts

export const REFRESH_TOKEN = "refresh_token"
export const ACCESS_TOKEN = "access_token"
export const ACCESS_TOKEN_EXPIRES = "access_token_expires"
export const SIDE_PANEL_WIDTH = 300
export const TOOLBAR_HEIGHT_SM_UP = 64
export const TOOLBAR_HEIGHT_SM_DOWN = 56
export const APP_MAX_WIDTH = 1440
export const DEFAULT_ACCESS_TOKEN_EXPIRY = 1000

// Regex

export const ISO_DATE_REGEX = /\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z)/
export const MONGODB_ID_REGEX = /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i

// Day of week
export const SUNDAY: DayOfWeek = 0
export const MONDAY: DayOfWeek = 1
export const TUESDAY: DayOfWeek = 2
export const WEDNESDAY: DayOfWeek = 3
export const THURSDAY: DayOfWeek = 4
export const FRIDAY: DayOfWeek = 5
export const SATURDAY: DayOfWeek = 6

export const treeGridColors: TreeGridColors[] = [
  "Default",
  "Aqua",
  "Black",
  "Blue",
  "Fuchsia",
  "Gray",
  "Green",
  "Lime",
  "Maroon",
  "Navy",
  "Olive",
  "Orange",
  "Purple",
  "Red",
  "Silver",
  "Teal",
  "White",
  "Yellow",
]

export const treeGridColorsMap: Record<TreeGridColors, string> = {
  Default: "#0288D1",
  Aqua: "#23D2D0",
  Black: "#141414",
  Blue: "#2196F3",
  Fuchsia: "#94067E",
  Gray: "#515151",
  Green: "#51AB09",
  Lime: "#44CC44",
  Maroon: "#951212",
  Navy: "#045CA1",
  Olive: "#9AA659",
  Orange: "#F39B10",
  Purple: "#CF12B2",
  Red: "#CF1212",
  Silver: "#808080",
  Teal: "#11B480",
  White: "#CCCCCC",
  Yellow: "#E8D10F",
}

/**
 * '0' - standard status color
 * '1' - color for 1st substatus
 * '2' - color for 2nd substatus
 * '3' - color for 3rd and above substatus
 */
export const STATUS_COLORS = {
  NOT_STARTED: {
    "0": "#D4D4D8",
    "1": "#A1A1AA",
    "2": "#71717A",
    "3": "#52525B",
  },
  IN_PROGRESS: {
    "0": "#38BDF8",
    "1": "#0EA5E9",
    "2": "#0284C7",
    "3": "#0369A1",
  },
  COMPLETED: {
    "0": "#34D399",
    "1": "#10B981",
    "2": "#059669",
    "3": "#047857",
  },
  REJECTED: {
    "0": "#FDA4AF",
    "1": "#FB7185",
    "2": "#F43F5E",
    "3": "#E11D48",
  },
}
export const OVERDUE_START_COLOR = "#fb923c"
